import React, { useEffect } from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import RichText from "@qlik/qlik/src/components/RichText";
import AnimationPageWhy from "@qlik/qlik/src/components/Animations/Why";
import svGatorWhyQlikAnimationFunction from "@qlik/qlik/src/components/Animations/Why/svGatorAnimationFunction";
import * as styles from "./styles.module.css";

/**
 * DeckAnimationContent component
 * This component renders a section with image content.
 * @param {Object} data - The data for the section.
 */
const DeckAnimationContent = ({ data }) => {
    const {
        customId,
        id,
        title,
        description,
        additionalConfiguration,
        backgroundColor,
        cardItems = [],
        cta = [],
        body,
    } = data ?? {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "py-15 md:py-20 lg:py-30");
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    // triger svg animation
    useEffect(() => {
        svGatorWhyQlikAnimationFunction();
        const element = document.getElementById("eEOjhQDWgHi1");
        element?.svgatorPlayer?.ready((player) => player.play());
    }, []);

    // Render the section with image content
    return (
        <section
            data-section
            id={customId || id}
            className={`scroll-mt-45 contain-paint ${sectionColorMapping.bgColor || ""} ${sectionSpacingClassName}`}
        >
            <div className="container">
                <div className="row">
                    <div className="section-content">
                        {/* Render the title if it exists */}
                        {title && (
                            <h2
                                className={`mb-5 title-2 text-center lg:tracking-tight10 ${sectionColorMapping.primaryTextColor}`}
                            >
                                {title}
                            </h2>
                        )}
                        {/* Render the description if it exists */}
                        {description?.description && (
                            <div className="text-center flex justify-center">
                                <p
                                    className={`text-md sm:text-2xl font-light leading-relaxed tracking-tight6 ${sectionColorMapping.primaryTextColor}`}
                                >
                                    {description?.description}
                                </p>
                            </div>
                        )}
                        {/* Render the body if it exists and neither background nor icon content are present */}
                        {body && (
                            <div className="col-12">
                                <RichText data={data} className="text-center mt-0.75" />
                            </div>
                        )}
                        {cta && (
                            <div className="col-12 pt-7.5 sm:pt-10 md:pt-25">
                                <div className="text-center flex justify-center">
                                    {cta?.map((button) => (
                                        <Cta key={button.id} data={button} />
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="max-w-[1570px] mx-auto">
                <div className="row">
                    <div className="section-content">
                        {cardItems && (
                            <div className={`${styles.svgAnimStyle} pt-12.5 lg:pt-25`}>
                                <AnimationPageWhy cardItems={cardItems} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};
export default DeckAnimationContent;
